import React, { useRef, useEffect } from "react";
import "../css/criticalinsurance.css";
import criticalinsuranceimg from "../assets/criticalinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const CriticalInsurance = () => {
    const API_URL = process.env.REACT_APP_Dashboard_API_URL;
    const imageRefs = useRef([]);
    const imageSources = [
        criticalinsuranceimg,
        tollfreenumberimg
    ];

    useEffect(() => {
        if (imageRefs.current.length > 0) {
            let index = 0;
            const showNextImage = () => {
                imageRefs.current.forEach((img, i) => {
                    if (img) img.style.display = i === index ? "block" : "none";
                });
                index++;
                if (index >= imageRefs.current.length) index = 0;
                setTimeout(showNextImage, 3000);
            };
            showNextImage();
        }
    }, []);

    const handleSubmit = async (data) => {
        const inquriyData = new FormData();
        inquriyData.append("Name", data.Name);
        inquriyData.append("Email", data.Email);
        inquriyData.append("PreferredDate", data.Date);
        inquriyData.append("PreferredTime", data.Time);
        inquriyData.append("MobileNo", data.MobileNo);
        inquriyData.append("Status", "New");
        inquriyData.append("UserId", data.Id);
        inquriyData.append("InquiryType", "Insurance Inquiries");
        inquriyData.append("PolicyType", "Critical Insurance");
        inquriyData.append("IsLoggedIn", data.isLoggedIn);
        inquriyData.append("Otp", data.OTP);

        try {
            const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return { status: response.status, data: response.data };
        } catch (error) {
            return {
                status: 500,
                data: { success: false, message: error.response?.data?.message }
            };
        }
    };

    return (
        <div className="criticalinsurance-container">
            <Helmet>
                <title>Critical Illness Insurance Consultation | Be Prepared</title>
                <meta name="description" content="Prepare for the unexpected with critical illness insurance consultation. Get personalized advice to safeguard your health and finances." />
                <link rel="canonical" href="https://policysamjho.com/critical-illness-insurance-consultation/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Critical Illness Insurance Consultation",
                        "description": "Expert consultation for choosing the right critical illness insurance policy. Understand benefits and ensure financial protection with Policy Samjho guidance.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "serviceType": "Critical Illness Insurance Advice",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/critical-illness-insurance-consultation/",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>

            <div className="criticalinsurance-hero-container">
                <div className="criticalinsurance-hero-text-box">
                    <h1>
                        <span style={{ color: '#192437' }}>Critical Illness </span>
                        <span style={{ color: '#F5A526' }}>Insurance Consultation</span>
                    </h1>
                    <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
                        Secure yourself and your family from the financial burden of critical
                        illnesses with a comprehensive insurance plan.
                    </p>
                </div>
                <div className="criticalinsurance-hero-image-box criticalinsurance-imgslider">
                    {imageSources.map((image, index) => (
                        <img
                            key={index}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}
                            className="criticalinsurance-sliderimg"
                            alt={`criticalinsurance-slide-${index}`}
                            style={{ display: index === 0 ? "block" : "none" }}
                        />
                    ))}
                </div>
            </div>

            <div className="criticalinsurance-containform-container">
                <div className="col-md-6 criticalinsurance-info">
                    <h2 className="criticalinsurance-heading">
                        <span style={{ color: '#192437' }}>What is </span>
                        <span style={{ color: '#F5A526' }}>Critical Insurance?</span>
                    </h2>
                    <p className="criticalinsurance-text">
                        Critical illness insurance provides financial support in case of serious
                        health conditions such as cancer, stroke, heart attack, or kidney failure.
                    </p>

                    <h2 className="criticalinsurance-subheading">
                        <span style={{ color: '#192437' }}>Why is Critical </span>
                        <span style={{ color: '#F5A526' }}> Insurance Important?</span>
                    </h2>
                    <ul className="criticalinsurance-benefits">
                        <li className="criticalpoints">Financial stability during treatment</li>
                        <li className="criticalpoints">Covers expensive medical procedures</li>
                        <li className="criticalpoints">Lump sum payout for serious illnesses</li>
                        <li className="criticalpoints">Supports recovery without financial stress</li>
                    </ul>

                    <h2 className="criticalinsurance-subheading">
                        <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
                        <span style={{ color: '#F5A526' }}>Health Benefits</span>
                    </h2>
                    <p className="criticalinsurance-text spaced-text">
                        Critical illness insurance ensures a lump sum payout for major health conditions,
                        helping cover medical costs, lifestyle adjustments, and lost income. It allows
                        patients to focus on recovery without worrying about finances. Coverage often
                        includes major illnesses like cancer, organ transplants, and neurological disorders.
                    </p>
                </div>

                <div>
                    <h4 className="consultationform-heading">
                        <span style={{ color: "#192437" }}>Get a Free </span>
                        <span style={{ color: "#F5A526" }}> Critical Insurance Consultation </span>
                    </h4>
                    <ConsultationForm onSubmit={handleSubmit} />
                </div>
            </div>

            <PoliciesSlider category="Critical Insurance" />
            <ChatbotAi />
        </div>
    );
};

export default CriticalInsurance;